import React, { useEffect } from "react";
import { saveAs } from "file-saver";
import { useDispatch, connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Base64 } from "js-base64";
import { downloadTranslatedFile } from "../Connector/Connector";
import { getText } from "../helpers/heper";
import { selectMachineTranslation, selectLanguages, selectTransUnits, selectSegments } from "../reducers/selectors";
import { updateStepperState } from "../reducers/stateManagmentReducer";
import { Button } from "react-bootstrap";
import { downloadTrasnlactedFileAction } from "../reducers/uploadReducer";
import DownloadFinish from "./Modals/DownloadFinish";
import { FadeLoader } from "react-spinners";
const DownloadFile = ({ translation, segments, file, download, updateStepperState, onOpen }) => {
  //Iterate through Nested JavaScript Objects
  //const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container card mt-5 animate__animated animate__fadeInRight">
      <DownloadFinish success={file.success} />
      <div className="row ps-4 pt-4">
        <div className="col-6">
          <div className="download-text">
            <p>
              <span>Download</span> file
            </p>
          </div>
        </div>
      </div>

      {file.isLoading === false ? (
        <div className="donwload-img row mx-auto">
          <p className="align-self-end">Almost done</p>
        </div>
      ) : (
        <div className="row loading-scrn">
          <FadeLoader className="align-self-center" height={20} width={7} radius={10} margin={12} color={"#43B4E9"}></FadeLoader>
          <span className="file-loading-text">Preparing your file...</span>
        </div>
      )}
      <div className="row">
        {file.success ? (
          <div className="d-flex justify-content-center">
            {/* <Button variant="primary" type="submit" onClick={() => updateStepperState({ activeStep: 0 })}> */}
            <Button variant="primary" type="submit" onClick={() => window.location.reload(false)}>
              Upload new file
            </Button>
          </div>
        ) : (
          <div className="d-flex justify-content-between px-5">
            <Button className="footer-btns" type="submit" onClick={() => updateStepperState({ activeStep: 2 })}>
              Previous Step
            </Button>
            <Button className="footer-btns" disabled={file.isLoading} onClick={() => download()}>
              Download
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    download: () => dispatch(downloadTrasnlactedFileAction()),
    updateStepperState: (activeStep) => dispatch(updateStepperState(activeStep)),
  };
};
const mapStateToProps = createStructuredSelector({
  translation: selectMachineTranslation,
  languages: selectLanguages,
  file: selectTransUnits,
  segments: selectSegments,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadFile);
